import axios from "axios";
import {
    baseURL
} from "..";

// Hàm để kiểm tra MVD
export const checkMVD = async (trackingList) => {
    try {
        const res = await axios.post(
            `${baseURL}/api/shopee/trackingList`, {
            trackingList
        }
        );
        return res.data;
    } catch (err) {
        console.error('Error checking MVD:', err);
        return null;
    }
};

// Hàm để tạo QR code
export const generateQRCode = async () => {
    try {
        const res = await axios.get(`${baseURL}/api/shopee/generate-qr-code`);
        return res.data.data;
    } catch (err) {
        console.error('Error generating QR code:', err);
        return null;
    }
};

export const checkQRCode = async (qrcodeId) => {
    try {
        const res = await axios.get(
            `${baseURL}/api/shopee/check-qr-status?qrcode_id=${encodeURIComponent(qrcodeId)}`
        );
        return res.data.data;
    } catch (err) {
        console.error('Error checking QR code status:', err);
        return null;
    }
};

export const loginQRCode = async (qrcodeToken) => {
    try {
        const res = await axios.post(
            `${baseURL}/api/shopee/login-qr`, {
            qrcodeToken
        });
        return res.data;
    } catch (err) {
        console.error('Error checking QR code status:', err);
        return null;
    }
};

export const getOrderDetailsForCookie = async (cookiesArray) => {
    try {
        // Gọi API với payload là đối tượng chứa mảng cookies
        const res = await axios.post(
            `${baseURL}/api/shopee/getOrderDetailsForCookie`, cookiesArray
        );
        return res.data;
    } catch (err) {
        console.error('Error fetching order details for cookies:', err);
        return null;
    }
};

export const saveVoucher = async (cookie) => {
    try {
        const res = await axios.post(`https://us-central1-auto-pee.cloudfunctions.net/app/v2/api/shopee/saveVoucher7`, {
            cookie,
        });
        return res.data;
    } catch (err) {
        console.error("Error addAddress:", err);
        return null;
    }
};

export const loginWithPassword = async (username, password, spc_f) => {
    try {
        const res = await axios.post(
            `${baseURL}/api/shopee/loginWithPassword`, {
            username, password, spc_f
        }
        );
        return res.data;
    } catch (err) {
        console.error('Error fetching loginWithPassword:', err);
        return null;
    }
};

export const getAllInfoShopee = async (cookie) => {
    try {
        const res = await axios.post(
            `${baseURL}/api/shopee/getAllInfoShopee`, {
            cookie
        }
        );
        return res.data;
    } catch (err) {
        console.error('Error fetching order details for cookies:', err);
        return null;
    }
};

export const checkPhone = async (phone) => {
    try {
        // Loại bỏ số 0 ở đầu, nếu tồn tại
        const formattedPhone = phone.startsWith("0") ? phone.slice(1) : phone;

        const res = await axios.get(
            `${baseURL}/api/shopee/checksoshopee?phone=${formattedPhone}`,
            {}
        );
        return res.data;
    } catch (err) {
        console.error("Error fetching checkPhone:", err);
        return null;
    }
};
